import { render } from "./ToggleFullscreenBtn.vue?vue&type=template&id=6a41fe5c&ts=true"
import script from "./ToggleFullscreenBtn.vue?vue&type=script&lang=ts"
export * from "./ToggleFullscreenBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__